<template>
  <master-main
    :addProperties="{
      isWizard: false,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('sigatoka.sigatoka_config')}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('sigatoka.sigatoka_config')}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 180,
      },
      {
        columnLabel: $t('sigatoka.number_leaves_to_evaluate'),
        data: 'sigatoka_config_leaves',
        property: 'leaf',
        minWidth: 180,
      },
    ]"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create
        v-if="renderComponent"
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        @refresh="refresh"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import i18n from 'src/i18n';
import { getDateToday } from 'src/util/Util';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import ConfigTable from 'src/views/Pages/Dashboard/Sigatoka/Config/config-table';
import EditCreate from 'src/views/Pages/Dashboard/Sigatoka/Config/EditCreate.vue';

export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '80%' },
    };
  },
  mixins: [
    MixinMain,
    MixinAlert,
    MixinLoading,
    MixinRerender,
    MixinWithDialog,
    MixinPermissions,
  ],
  computed: {
    getModuleRoute() {
      return 'sigatoka/config';
    },
    dateToday() {
      return getDateToday();
    },
    buildTableProperties() {
      return {
        tableColumns: [...ConfigTable().tableColumns],
        model: 'sigatokaconfig',
        effectTags: 'dark',
        defaultSort: { prop: 'businesses', order: 'ascending' },
        addColumns: [
          {
            data: 'sigatoka_config_leaves',
            label: i18n.t('sigatoka.number_leaves_to_evaluate'),
            field: 'leaf',
          },
        ],
      };
    },
  },
};
</script>
